export default __webpack_public_path__ + "static/media/notadirect.7530b2e1.png";